import { GenericModelApi, FetchOpts } from "./GenericModelApi";
import { ApiClient, ApiSchema, NotFoundError } from "./ApiClient";
import { ClientFormData } from "@/formTypes/ClientFormDataType";
import { getTenantId } from "@utils/Auth";
import { buildClientOptionLabel } from "@utils/ClientLabel";

export type ClientDataType = Partial<ApiSchema["Client"]["type"] & ClientFormData>;

class Api extends GenericModelApi<"Client", ClientDataType> {

    async fetchAll(amplifyClientFilter?: AmplifyFilter,
        token?: string,
        limit = 20,
        selectionSet?: any,
        opts: FetchOpts = {})
        : Promise<FetchResponse<ProductDataType>> {
        this.apiMaxFetch = 100

        return super.fetchAll(amplifyClientFilter,
            token,
            limit,
            selectionSet,
            opts)
    }

    /**
     * Todos los selects de cliente del sistema pasan por aqui, asi que la etiqueta con el
     * nombre comercial se resuelve en un solo lugar. Un `labelGenerator` explicito sigue
     * teniendo prioridad.
     */
    async optionsList(filters: any = {},
        labelGenerator?: (item: ClientDataType) => string,
        valueProp: keyof ClientDataType = "id"
    ): Promise<Record<string, string>> {
        return super.optionsList(filters, labelGenerator ?? buildClientOptionLabel, valueProp);
    }

    async getClientByCode(codigo: string,
        selectionSet?: any
    ): Promise<ClientDataType> {
        const tenantId = await getTenantId();

        const fetchFunction = ApiClient.models[this.modelName][`list${this.modelName}ByTenant`];
        const { data, errors, nextToken: nt } = await fetchFunction({
            owner: tenantId,
            codigo: { eq: codigo },
        }, {
            limit: 1,
            selectionSet: selectionSet,
        });

        if (errors) {
            throw new NotFoundError(`Error al obtener el cliente por cordigo`, "API_ERROR", errors);
        }
        if (data.length > 0) {
            return data[0]
        } else {
            throw new NotFoundError(`No existe ningun cliente con el codigo ingresado`, "API_ERROR", errors);
        }

    }

}

export const ClientApi = new Api("Client", "nombre")